// All page texts in one object (headings, intros, form texts).
// Loaded once by SiteContext -> available everywhere as useSite().content.
// Backend later: one endpoint (e.g. /api/page-content/) returns this same shape.
import * as content from "./content";
import { assessmentContent } from "./assessments";
import { anonymousContent } from "./messages";
import { licensesContent, awardsContent } from "./credentials";
import { videosContent } from "./videos";
import { faqContent } from "./faqs";
import admission from "./admission";
import packageCompare from "./packageCompare";
import seo from "./seo";

const pageContent = {
  ...content,
  assessmentContent,
  anonymousContent,
  licensesContent,
  awardsContent,
  videosContent,
  faqContent,
  admission,
  packageCompare,
  seo,
};

export default pageContent;
